import React, { Component } from 'react'
import { SNavigation, SText, STheme, SView } from 'servisofts-component2';
import BackArrow from "../../../Assets/backArrow.svg"
import { TopBarPropsType } from '..';
export default class index extends Component<TopBarPropsType> {

    getBack() {
        if (this.props.preventBack) {
            return null;
        }
        return <SView col={"xs-12"} height center >
            <SView onPress={() => {
                if (this.props.onBack) {
                    var prevent_default = this.props.onBack();
                    if (prevent_default) {
                        return;
                    }
                }
                SNavigation.goBack();
            }} col={"xs-12"} style={{
                paddingBottom: 4,
            }} center height>
                <BackArrow height={18} fill={STheme.color.secondary} />
            </SView>
        </SView>
    }
    render() {
        return (<SView col={"xs-12"} height={50} backgroundColor={STheme.color.barColor} center row>
            <SView width={50} height>
                {this.getBack()}
            </SView>
            <SView flex height center>
                <SText color={STheme.color.secondary}>{this.props.title}</SText>
            </SView>
            <SView width={50} height></SView>
        </SView>)
    }
}